import { DATE_TIME_LOCAL_FORMAT } from "@dgs/core";
import { isBefore, isEqual, parse, parseISO } from "date-fns";
import { DataFieldType } from "../../../shared/types";
import { DataFieldRuleValidator } from "./types";

export const dataFieldLessThanEqual: DataFieldRuleValidator = {
	validate({ isImplicitlyRequired }, dataFieldType, dataFieldValue, ruleValue): boolean {
		if (dataFieldValue === null || dataFieldValue === undefined || !ruleValue) {
			return !isImplicitlyRequired;
		}

		switch (dataFieldType) {
			case DataFieldType.CRYPT:
			case DataFieldType.NUMBER:
				return (dataFieldValue as number) <= (ruleValue as number);
			case DataFieldType.TIME:
				return (dataFieldValue as string) <= (ruleValue as string);
			case DataFieldType.DATETIME:
				return (
					isBefore(parseISO(dataFieldValue as string), parseISO(ruleValue as string)) ||
					isEqual(parseISO(dataFieldValue as string), parseISO(ruleValue as string))
				);
			case DataFieldType.LOCAL_DATETIME:
				return (
					isBefore(
						parse(dataFieldValue as string, DATE_TIME_LOCAL_FORMAT, new Date()),
						parse(ruleValue as string, DATE_TIME_LOCAL_FORMAT, new Date()),
					) ||
					isEqual(
						parse(dataFieldValue as string, DATE_TIME_LOCAL_FORMAT, new Date()),
						parse(ruleValue as string, DATE_TIME_LOCAL_FORMAT, new Date()),
					)
				);
			case DataFieldType.DATE:
				return (
					isBefore(
						parse(dataFieldValue as string, "yyyy-MM-dd", new Date()),
						parse(ruleValue as string, "yyyy-MM-dd", new Date()),
					) ||
					isEqual(
						parse(dataFieldValue as string, "yyyy-MM-dd", new Date()),
						parse(ruleValue as string, "yyyy-MM-dd", new Date()),
					)
				);
			case DataFieldType.MULTI_SELECT_FIELD:
			case DataFieldType.CHECKBOX_GROUP:
				return (dataFieldValue as []).length <= (ruleValue as number);
		}
		return false;
	},
	getErrorMessage({ t, formatDate, formatDateTime }, dataField, _, ruleValue): string {
		switch (dataField.type) {
			case DataFieldType.DATE:
				return t("Field has maximum value of {{value}}", { value: formatDate(ruleValue as string) });
			case DataFieldType.DATETIME:
			case DataFieldType.LOCAL_DATETIME:
				return t("Field has maximum value of {{value}}", { value: formatDateTime(ruleValue as string) });
			case DataFieldType.CHECKBOX_GROUP:
			case DataFieldType.MULTI_SELECT_FIELD:
				return t("Field has maximum {{count}} values", { count: Number(ruleValue) });
			default:
				return t("Field has maximum value of {{value}}", { value: ruleValue });
		}
	},
};
